// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__305ah","inner":"Form_inner__2q2ul","range":"Form_range__3KCub","name":"Form_name__VgHHP","actions":"Form_actions__2lYnz"};